import type {PublicMethodUtils} from '@wix/document-services-types'
import type {BuilderComponentsPublicAPI} from '@wix/document-services-public-types'
import {builderComponents} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<BuilderComponentsPublicAPI> {
    const {defineAction, defineGetter, deprecate} = publicMethodUtils
    return {
        methods: {
            builder: {
                components: {
                    register: deprecate(
                        defineAction(() => {}),
                        'builder.components.register is deprecated! You should load your components by installing the application with the builder components'
                    ),
                    getCompAppData: defineGetter(builderComponents.getCompAppData)
                }
            }
        }
    }
}
